import isEqual from "lodash/isEqual";

export const getSafe = (fn, defaultVal) => {
	try {
		return fn();
	} catch (e) {
		return defaultVal;
	}
};

export const getSafeOrDefault = (fn, defaultVal) => {
	return getSafe(fn, defaultVal) || defaultVal;
};

export const getByPath = (obj, path) => {
	return path
		.split(".")
		.reduce(
			(p, c) => (p && (p[c] !== null || p[c] !== undefined) ? p[c] : null),
			obj
		);
};

export const getMax = (arr = [], prop) => {
	return arr
		.filter((item) => item[prop])
		.reduce((prev, curr) => {
			return prev[prop] > curr[prop] ? prev : curr;
		});
};

export const setSafePath = (obj = {}, [first, ...rest], value) => ({
	...obj,
	[first]: rest.length ? setSafePath(obj[first], rest, value) : value
});

export const getMin = (arr = [], prop) => {
	return arr
		.filter((item) => item[prop])
		.reduce((prev, curr) => {
			return prev[prop] < curr[prop] ? prev : curr;
		});
};

const padZero = (str, length) => {
	const len = length || 2;
	const zeros = new Array(len).join("0");
	return (zeros + str).slice(-len);
};

const isValidHexColor = (hex) => /^#([0-9a-f]{3}){1,2}$/i.test(hex);

export const invertColor = (hexa, bw, defaultColor = "#FFFFFF") => {
	if (!isValidHexColor(hexa)) {
		return defaultColor;
	}

	let hex = hexa;
	if (hex.indexOf("#") === 0) {
		hex = hex.slice(1);
	}
	// convert 3-digit hex to 6-digits.
	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	let r = parseInt(hex.slice(0, 2), 16);
	let g = parseInt(hex.slice(2, 4), 16);
	let b = parseInt(hex.slice(4, 6), 16);
	if (bw) {
		return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
	}
	// invert color components
	r = (255 - r).toString(16);
	g = (255 - g).toString(16);
	b = (255 - b).toString(16);
	// pad each with zeros and return
	return `#${padZero(r)}${padZero(g)}${padZero(b)}`;
};

export const isDefined = (a) => {
	return typeof a !== "undefined" && a !== null;
};

// A form field differs from what was loaded. For primitives the string
// fallback treats an input's "5" and a stored 5 as the same value, so retyping
// the original does not leave the field marked as changed.
export const isValueChanged = (values, initialValues, path) => {
	const value = getByPath(values, path);
	const initialValue = getByPath(initialValues, path);
	const bothPrimitive =
		!(value instanceof Object) && !(initialValue instanceof Object);
	return (
		!isEqual(value, initialValue) &&
		!(bothPrimitive && String(value) === String(initialValue))
	);
};
